import React, { useEffect } from "react";
import "./Loader.css";
export default function Loader({ isVisible }) {
  useEffect(() => {
    if (isVisible) {
        document.body.style.overflow = "hidden";
    } else {
        document.body.style.overflow = "auto";
    }
    return () => {
        document.body.style.overflow = "auto";
    };
}, [isVisible]);

if (!isVisible) return null;

  return (
    <div className="logo-overlay">
      <img src=" ../assets/img/logo.png" alt="Website Logo" className="logo-loader" />
     
    </div>
  );
}
